export default __webpack_public_path__ + "static/media/READY_TO_SCAN_CONTAINERS.2a8341fb.svg";